
export * from './b2.component';
export * from './b2-inbody.component';

